/* eslint-disable import/no-commonjs */

import docsearch from './src/lib/main';
module.exports = docsearch;



// WEBPACK FOOTER //
// ./index.js